//This functionality is created to delete stale records and their attachments.
//The expiryAt flag on a record is used to distinguish active/valid records from those that need to be purged.
var _ = require('underscore');
var _PURGEADMIN = 'RecordPurgeAdministrator';
var Entities = require('Entities');
var Solr = require('Solr');
var StatusType = EY.Consultation.Lookups.StatusType;
var Lookups = EY.Consultation.Lookups; 
var query = function () {
    var today = new Date().toISOString();
    var user = EY.Consultation.CurrentUser;
    return {
        aggregate: [{
            $project: {
                _id: 1, id: 1, attachments: 1, countryId: 1, geographyId: 1, statusTypeId: 1, zoneKey: 1,
                expiredMilliseconds: { $subtract: [{ $dateFromString: { dateString: today } }, { $dateFromString: { dateString: "$expiryAt", onError: { $dateFromString: { dateString: today } } } }] }
            }
        }, {
            $match: {
                $and: [
                    { geographyId: { $regex: user.geographyByRole[_PURGEADMIN] } },
                    { expiredMilliseconds: { $gt: 0 } },
                    { $nor: [{ statusTypeId: StatusType.Complete }, { statusTypeId: StatusType.UsersNotified }] }
                ]
            }
        }]
    };
};

var purge = function () {
    var records = new Entities.Records();

    records.fetch(query()).then(function () {
        var logger = require('Logger');

        logger.log('Total records to purge: ' + records.length);
        records.each(function (record) {
            //1. Delete attachments...
            _.each(record.get('attachments'), function (attachment) {
                _.extend(new Entities.Attachment({ id: attachment.id }), { urlRoot: (Lookups.RedBoxCountryApi[record.get('countryId')] || record.urlRoot.replace('/Record', '/')) + 'Attachment' }).destroy({ data: { zone: attachment.zone }, processData: true });

                Solr.delete({ id: attachment.id });
            });

            //2. Delete Record Notification...
            new Entities.RecordNotification({ id: record.id }).destroy();

            //3. Delete Record...
            _.extend(new Entities.Record({ id: record.id }), { urlRoot: (Lookups.RedBoxCountryApi[record.get('countryId')] || record.urlRoot.replace('/Record', '/')) + 'Record' }).destroy({ data: { 'zoneKey': record.get("zoneKey") + "" }, processData: true });
        });
    });
};

module.exports.run = function () {
    var user = EY.Consultation.CurrentUser;

    user.geographyByRole[_PURGEADMIN] && purge();
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordPurge.js